import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=ffbbc290&scoped=true&"
import script from "./NewOrder.vue?vue&type=script&lang=js&"
export * from "./NewOrder.vue?vue&type=script&lang=js&"
import style0 from "./NewOrder.vue?vue&type=style&index=0&id=ffbbc290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbbc290",
  null
  
)

export default component.exports